import { render } from "./MainSidebar.vue?vue&type=template&id=206232ee&scoped=true"
import script from "./MainSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./MainSidebar.vue?vue&type=script&setup=true&lang=js"

import "./MainSidebar.vue?vue&type=style&index=0&id=206232ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206232ee"],['__file',"src/components/layout/MainSidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "206232ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('206232ee', __exports__)) {
    api.reload('206232ee', __exports__)
  }
  
  module.hot.accept("./MainSidebar.vue?vue&type=template&id=206232ee&scoped=true", () => {
    api.rerender('206232ee', render)
  })

}


export default __exports__